import { useSetState } from './use-set-state.js';

export const useSetOverlayState = () => {
  const setState = useSetState();

  const setOverlayStateInBounds = (mouseInBounds: boolean) => {
    setState((prev) => {
      return {
        ...prev,
        overlay: {
          mouseInBounds,
        },
      };
    });
  };

  return {
    setOverlayStateInBounds,
  };
};
